import validationService from '../services/validation.services'
import { ValidationConstants } from './validation.constants'
import { InputValidationInputs, IValidationState } from './validation.types'

export const initialValidationState: IValidationState = {
  currentNamespace: '',
  currentAction: '',
  currentValue: '',
  currentCardinalityKey: '',
  currentConditionalValue: '',
  currentInputValidationElement: null,
  ruleReadyActions: new Set(),
}

export function validationReducer(state: IValidationState = initialValidationState, action: any): IValidationState {
  switch (action.type) {
    case ValidationConstants.SETUP_INPUT_VALIDATION: {
      const inputValidationInputs = <InputValidationInputs>action.inputValidationInputs

      return {
        ...state,
        currentNamespace: validationService.getNamespaceForType(inputValidationInputs.action),
        currentAction: inputValidationInputs.action,
        currentValue: inputValidationInputs.value,
        currentCardinalityKey: inputValidationInputs.cardinalityKey,
        currentConditionalValue: inputValidationInputs.conditionalValue,
        currentInputValidationElement: validationService.getInputValidationElementForId(
          inputValidationInputs.action,
          inputValidationInputs.cardinalityKey
        ),
      }
    }
    case ValidationConstants.RESET_VALIDATION_STATE: {
      validationService.resetState()

      return {
        currentNamespace: '',
        currentAction: '',
        currentValue: '',
        currentCardinalityKey: '',
        currentConditionalValue: '',
        currentInputValidationElement: null,
        ruleReadyActions: new Set(),
      }
    }
    default:
      return state
  }
}
